module.exports = __webpack_public_path__ + "static/media/brenchmarkWitness.aa63b49b.webp";